import React from 'react';
import PropTypes from 'prop-types';

function RupeeIcon({ color = 'black', width = 16, height = 16 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00065 14.6663C4.31865 14.6663 1.33398 11.6817 1.33398 7.99967C1.33398 4.31767 4.31865 1.33301 8.00065 1.33301C11.6827 1.33301 14.6673 4.31767 14.6673 7.99967C14.6673 11.6817 11.6827 14.6663 8.00065 14.6663ZM8.00065 13.333C9.41514 13.333 10.7717 12.7711 11.7719 11.7709C12.7721 10.7707 13.334 9.41416 13.334 7.99967C13.334 6.58519 12.7721 5.22863 11.7719 4.22844C10.7717 3.22824 9.41514 2.66634 8.00065 2.66634C6.58616 2.66634 5.22961 3.22824 4.22942 4.22844C3.22922 5.22863 2.66732 6.58519 2.66732 7.99967C2.66732 9.41416 3.22922 10.7707 4.22942 11.7709C5.22961 12.7711 6.58616 13.333 8.00065 13.333Z"
        fill={color}
      />
      <path
        d="M10 5.75V5H6V5.75H7.27273C7.74618 5.75 8.14582 6.06425 8.29636 6.5H6V7.25H8.29636C8.22172 7.46871 8.08324 7.65823 7.89996 7.79252C7.71667 7.92681 7.49756 7.99929 7.27273 8H6V8.90525L8.03127 11H9.05964L6.87782 8.75H7.27273C7.69162 8.74942 8.09751 8.59991 8.42196 8.32666C8.74641 8.05342 8.96957 7.67316 9.05382 7.25H10V6.5H9.05382C8.99808 6.22708 8.88321 5.97068 8.71782 5.75H10Z"
        fill={color}
      />
    </svg>
  );
}

RupeeIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default RupeeIcon;
